import React, { useEffect, useState } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { Divider } from 'primereact/divider';

const LanguageProficiency = ({
  languageOptions, 
  proficiencyOptions, 
  translation,
  onChange,
  value,
  hasError,
  errorMessage,
  disabled,
}) => {
  const [entries, setEntries] = useState(value || [{ languageCode: null, proficiencyCode: null }]);

  const addEntry = () => {
    if (entries.length < 7) {
      setEntries([...entries, { languageCode: null, proficiencyCode: null }]);
    }
  };

  const removeEntry = (index) => {
    if (disabled) return;
    if (entries.length <= 1) return;
    const newEntries = [...entries];
    newEntries.splice(index, 1);
    setEntries(newEntries);
  };

  const handleChange = (index, field, value) => {
    const newEntries = [...entries];
    newEntries[index][field] = value;
    setEntries(newEntries);
  };

  // Filter language options for each dropdown to exclude already selected languages
  const getFilteredLanguageOptions = (currentIndex) => {
    const selectedLanguages = entries
      .map((entry, index) => index !== currentIndex ? entry.languageCode : null)
      .filter(lang => lang !== null && lang !== "");
    
    return languageOptions.filter(option => !selectedLanguages.includes(option.code));
  };

  const itemTemplate = (option) => (
    <div className="justify-content-start align-items-center flex gap-1">
      <div className="keduall-icon flag-circle-country small-size justify-content-center align-items-center flex">
          <span className={`flag img flex ${option.flag}`} />
      </div>
      <div className="flex keduall-typography text-16-normal-400 text-default-txt">{option.name}</div>
    </div>
  );

  const selectedLanguageTemplate = (option, props) => {
    if (option) {
      return (
        <div className="justify-content-start align-items-center flex gap-1">
          <div className="keduall-icon flag-circle-country small-size justify-content-start align-items-center flex">
              <span className={`flag img flex ${option.flag}`} />
            </div>
          <span className='flex keduall-typography text-16-normal-400 text-default-txt'>{option.name}</span>
        </div>
      );
    }
    return <span className='p-placeholder'>{props.placeholder}</span>;
  };

  const selectedProficiencyTemplate = (option, props) => {
    if (option) {
      return (
        <div className="text-default-txt input-default-default keduall-typography text-16-normal-400">
          {option.label}
        </div>
      );
    }
    return <span className='p-placeholder'>{props.placeholder}</span>;
  };

  useEffect(() => {
    onChange(entries);
  },[entries])

  return (
    <div className="language-speaking box w-full">
      <div className="header">
        <div className="header-title">
          <div className="main-title keduall-typography heading-h5-semibold-600 text-default-txt">
            {translation.title}
          </div>
        </div>
        <div className="add-icon cursor-pointer" onClick={addEntry}>
          <i className="pi pi-plus"></i>
        </div>
      </div>

      <div className="divider"></div>

      <div className="content flex-wrap md:flex-nowrap">
        <div className="entries keduall-typography text-16-normal-400 flex flex-column">
          {entries && entries.length > 0  && entries.map((entry, index) => (
            <div key={index} className="entry-row flex flex-row flex-wrap md:flex-nowrap">
              <div className="col language-col w-full">
                <div className="col language-header">
                  <label className='keduall-typography text-16-normal-400 text-default-txt'>
                    {translation.languageLabel}&nbsp;<span className="p-error">*</span>
                  </label>
                </div>
                <Dropdown
                  key="language-col"
                  options={getFilteredLanguageOptions(index)}
                  value={entry.languageCode || ""}
                  onChange={(e) => handleChange(index, 'languageCode', e.value)}
                  optionLabel="name"
                  optionValue="code"
                  placeholder={translation.languagePlaceholder}
                  showClear={true}
                  panelClassName="keduall-form dropdown-input-panel"
                  filter={true}
                  className={`w-full keduall-form text-default-txt input-default-default keduall-typography text-16-normal-400 ${
                    hasError && (!entry.languageCode) ? 'p-invalid' : ''
                  }`}
                  valueTemplate={selectedLanguageTemplate}
                  itemTemplate={itemTemplate}
                  appendTo="self"
                  disabled={disabled}
                />
                {hasError && (!entry.languageCode) && errorMessage && errorMessage()}
              </div>
              
              <div className="col proficiency-col w-full">
                <div className="col proficiency-header">
                  <label className='keduall-typography text-16-normal-400 text-default-txt'>
                    {translation.proficiencyLabel}&nbsp;<span className="p-error">*</span>
                  </label>
                </div>
                <Dropdown
                  key="proficiency-col"
                  options={proficiencyOptions}
                  value={entry.proficiencyCode || ""}
                  onChange={(e) => handleChange(index, 'proficiencyCode', e.value)}
                  optionLabel="label"
                  optionValue="value"
                  placeholder={translation.proficiencyPlaceholder}
                  showClear={true}
                  className={`w-full keduall-form text-default-txt input-default-default keduall-typography text-16-normal-400 ${
                    hasError && (!entry.proficiencyCode) ? 'p-invalid' : ''
                  }`}
                  valueTemplate={selectedProficiencyTemplate}
                  itemTemplate={(option) => (
                    <div className="dropdown-item ">
                      {option.label}
                    </div>
                    )
                  }
                  appendTo="self"
                  disabled={disabled}
                />

                {hasError && (!entry.proficiencyCode) && errorMessage && errorMessage()}

              </div>
              {entries.length > 1 && (
                <div className="remove-icon w-full md:w-auto flex justify-content-center" onClick={() => removeEntry(index)}>
                  <i className="pi pi-trash"></i>
                </div>
              )}
              <Divider className="md:hidden w-full"></Divider>
            </div>
            
          ))}
        </div>
      </div>
    </div>
  );
};

export default LanguageProficiency;